import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

import VPDarkIcon from '@theme/VPDarkIcon.vue'
import VPLightIcon from '@theme/VPLightIcon.vue'
import { useDarkMode } from '@theme/useDarkMode'
import { useThemeLocaleData } from '@theme/useThemeData'


export default /*@__PURE__*/_defineComponent({
  __name: 'VPToggleColorModeButton',
  setup(__props) {

const themeLocale = useThemeLocaleData()
const isDarkMode = useDarkMode()

const toggleColorMode = (): void => {
  isDarkMode.value = !isDarkMode.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "vp-toggle-color-mode-button",
    title: _unref(themeLocale).toggleColorMode,
    onClick: toggleColorMode
  }, [
    _withDirectives(_createVNode(VPLightIcon, null, null, 512), [
      [_vShow, !_unref(isDarkMode)]
    ]),
    _withDirectives(_createVNode(VPDarkIcon, null, null, 512), [
      [_vShow, _unref(isDarkMode)]
    ])
  ], 8, _hoisted_1))
}
}

})